// Nav dropdown feature tiles (snippets/nta-menu-feature.liquid): pick one
// Best Seller at random for each dropdown, avoiding the same product in two
// dropdowns when there are enough to go around. The first option is already
// in place, so without this script it simply shows.

const used = new Set();

const features = Array.from(document.querySelectorAll('[data-nta-feature]'), (feature) => {
  const templates = feature.querySelectorAll(':scope > template[data-nta-feature-option]');
  const options = [
    { id: feature.dataset.productId, template: null },
    ...Array.from(templates, (template) => ({ id: template.dataset.productId, template })),
  ];
  return { feature, options };
});

// Dropdowns with the fewest options pick first, so a wide one (Collections)
// doesn't take the only product a narrower one (Men or Women) could show
features.sort((a, b) => a.options.length - b.options.length);

for (const { feature, options } of features) {
  const unused = options.filter((option) => !used.has(option.id));
  const pool = unused.length > 0 ? unused : options;
  const pick = pool[Math.floor(Math.random() * pool.length)];
  used.add(pick.id);

  const current = feature.querySelector(':scope > a');
  if (!pick.template || !current) continue;
  current.replaceWith(document.importNode(pick.template.content, true));
  feature.dataset.productId = pick.id;
}
